module.exports = __webpack_public_path__ + "static/img/Vizio-Default.6223798.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Vizio-Default.png
// module id = 2180
// module chunks = 0